import { polygon } from '../paint';
import type { Ctx, Piece } from '../paint';

const OUT = 'rgba(4,6,18,.9)';
const FIRE = '#ff7a3d';
const FLAME = '#ffdc5a';
const EARTH = '#e0a84a';
const EARTH_DEEP = '#80592a';

export const TONGUE = 15;

function fillOut(ctx: Ctx, fill: string, width = 0): void {
  ctx.fillStyle = fill;
  ctx.fill();
  if (width > 0) {
    ctx.lineWidth = width;
    ctx.lineJoin = 'round';
    ctx.strokeStyle = OUT;
    ctx.stroke();
  }
}

// A flame tongue from its base at the origin to its tip along -x.
function flamePath(ctx: Ctx, length: number, width: number, sway: number): void {
  ctx.beginPath();
  ctx.moveTo(0, -width);
  ctx.quadraticCurveTo(-length * 0.45, -width * 1.15 + sway * 0.3, -length, sway * 0.35);
  ctx.quadraticCurveTo(-length * 0.45, width * 1.15 + sway * 0.3, 0, width);
  ctx.closePath();
}

// Painted pointing +x from the left edge, so a sprite anchored at 0 turns about its base.
function tongue(ctx: Ctx): void {
  ctx.translate(-TONGUE / 2 - 1, 0);
  ctx.scale(-1, 1);
  flamePath(ctx, TONGUE, 3.6, 0.6);
  fillOut(ctx, FIRE, 1.1);
  flamePath(ctx, TONGUE * 0.62, 1.8, 1);
  fillOut(ctx, FLAME);
}

function rock(ctx: Ctx): void {
  polygon(ctx, [
    [-3, -2],
    [0, -3.4],
    [3.2, -1.4],
    [2.6, 2.2],
    [-1, 3],
    [-3.4, 1],
  ]);
  fillOut(ctx, EARTH, 0.8);
  polygon(ctx, [
    [0, -3.4],
    [3.2, -1.4],
    [2.6, 2.2],
    [0.6, 0.2],
  ]);
  fillOut(ctx, EARTH_DEEP);
}

export const MARK_PIECES = {
  tongue: [TONGUE + 2, 10, TONGUE, tongue],
  rock: [10, 10, 4, rock],
} satisfies Record<string, Piece>;
